import axios from 'axios';
import config from "@/composables/Config";
import {getToken} from "@/Helper";

const API_URL = process.env.API_URL;

let client = (baseUrl = null, additionalHeaders = {}) => {
	let defaultHeaders = {
		'Content-Type': 'application/json'
	};

	const accessToken = getToken();
	if ((Object.keys(additionalHeaders).length === 0) && accessToken && accessToken.length > 0) {
		defaultHeaders['authorization'] = 'Bearer ' + accessToken;
	}

	let axiosOptions = {
		baseURL: baseUrl
	};

	axiosOptions.headers = {
		...defaultHeaders,
		...additionalHeaders,
	};
	return axios.create(axiosOptions);
};

class ApiClientFactory {
	constructor(baseUrl = null) {
		if (baseUrl == null) {
			baseUrl = API_URL;
		}

		let apiVersion = config.general.api_version;
		this.baseUrl = baseUrl + '/' + apiVersion + '/'
	}

	get(url, requestData = {}, headers = {}, ignoreCredentials = false) {
		return client(this.baseUrl, headers, ignoreCredentials).get(url, requestData);
	}

	post(url, requestData = {}, headers = {}, ignoreCredentials = false) {
		return client(this.baseUrl, headers, ignoreCredentials).post(url, requestData);
	}

	put(url, requestData = {}, headers = {}, ignoreCredentials = false) {
		return client(this.baseUrl, headers, ignoreCredentials).put(url, requestData);
	}

	delete(url, requestData = {}, headers = {}, ignoreCredentials = false) {
		return client(this.baseUrl, headers, ignoreCredentials).delete(url, requestData);
	}
}

export { ApiClientFactory };
